<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 协议价管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-form :inline="true" :model="query" ref="query">
                <el-form-item  label="单品名称" prop="skuName" >
                    <el-input v-model="query.skuName" placeholder="单品名称"></el-input>
                </el-form-item>
                <el-form-item  label="单品编号" prop="skuNumber" >
                    <el-input v-model="query.skuNumber" placeholder="单品编号" class="handle-input mr10"></el-input>
                </el-form-item>
                <el-form-item  label="协议编号" prop="agreeNumber" >
                    <el-input v-model="query.agreeNumber" placeholder="协议编号" class="handle-input mr10"></el-input>
                </el-form-item>
                <el-form-item  label="所属分类" prop="category" >
                    <el-input v-model="query.category" placeholder="所属分类" class="handle-input mr10"></el-input>
                </el-form-item>
                <el-form-item  label="上架状态" prop="putOnStatus" >
                    <el-select v-model="query.putOnStatus" placeholder="上架状态" class="handle-input mr10">
                        <el-option :value="1" label="是"></el-option>
                        <el-option :value="0" label="否"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
            <el-button type="primary" icon="el-icon-delete" @click="handleClear">重置</el-button>
        </div>
        <div class="container">
            <div style="margin-bottom: 20px">
                <el-button @click="handleAdd" >新增</el-button>
                <el-button @click="handleAdjustPrice">在线调价</el-button>
                <el-button>批量调价</el-button>
                <el-button>批量删除</el-button>
                <el-button>数据导出</el-button>
                <el-button>查看任务</el-button>
            </div>
            <TableList
                    :table-label="tableLabel"
                    :loading="loading"
            ></TableList>

            <div class="pagination">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="productTagPage.currentPage"
                        :page-size="productTagPage.pageSize"
                        :total="productTagPage.pageTotal"
                        :small="true"
                >
                </el-pagination>
            </div>
        </div>
        <OnlineAjustPrice
                :dialogTitle="dialogTitle"
                :centerDialogVisible="visible"
                @updateVisible="updateVisible"
                @resetPopupData="resetPopupData"
                @submitPopupData="submitPopupData"
                :popupWidth="'500px'"
        >
            <el-form>
                <el-form-item label="调价方式:">
                <el-select style="width: 30%" v-model="adjustPriceWay">
                    <el-option :value="0" label="按比例降幅"></el-option>
                    <el-option :value="1" label="按比例增幅"></el-option>
                    <el-option :value="2" label="按数值增幅"></el-option>
                    <el-option :value="3" label="按数值降幅"></el-option>
                    <el-option :value="4" label="固定价"></el-option>
                </el-select>
            </el-form-item>
                <el-form-item label="增幅比例(%):">
                    <el-input style="width: 30%" v-model="adjustValue"></el-input>
                </el-form-item>
            </el-form>
        </OnlineAjustPrice>
    </div>
</template>

<script>
    import TableList from '../../../../components/common/table-list'
    import OnlineAjustPrice from '../../../../components/common/epecDialog'
    export default {
        name: "agreementPrice",
        components: {
            TableList,
            OnlineAjustPrice
        },
        props: {},
        data() {
            return {
                loading:false,
                tableData:[{id:1,company:'1',status:0},{id:2,company:'2',status:1}],
                tableLabel: [
                    { label: 'id', param: 'id',  align: 'center', type:'selection',fixed:'left'},
                    { label: '单品图片', param: 'company', align: 'center' ,slot:'company',fixed:'left'},
                    { label: '单品名称', param: 'email', align: 'center',width:'200' ,fixed:'left'},
                    { label: '单品编号', param: 'registTime', align: 'center' ,slot:'time'},
                    { label: '品牌', param: 'status', align: 'center', render:  (row) => {
                            if (row.status === 0) {
                                return '<h3>未审核</h3>'
                            } else if (row.status === 1) {
                                return '审核通过'
                            } else if(row.status ===2) {
                                return '审核不通过'
                            } else {
                                return '禁用'
                            }
                        }
                    },
                    { label: '所属分类', param: 'registTime', align: 'center' },
                    { label: '协议编号', param: 'registTime', align: 'center' },
                    { label: '协议名称', param: 'registTime', align: 'center' },
                    { label: '协议状态', param: 'registTime', align: 'center' },
                    { label: '上架状态', param: 'registTime', align: 'center' },
                    { label: '系列', param: 'registTime', align: 'center' },
                    { label: '滚动体列数', param: 'registTime', align: 'center' },
                    { label: '内径', param: 'registTime', align: 'center' },
                    { label: '外径', param: 'registTime', align: 'center' },
                    { label: '宽度', param: 'registTime', align: 'center' },
                    { label: '密封防尘形式', param: 'registTime', align: 'center' },
                    { label: '保持架材质', param: 'registTime', align: 'center' },
                    { label: '库存', param: 'stock', align: 'center' ,slot:'stock'},
                    { label: '起订量', param: 'registTime', align: 'center' },
                    { label: '订单是否确认', param: 'registTime', align: 'center' },
                    { label: '发货周期(天)', param: 'registTime', align: 'center' },
                    { label: '计量单位', param: 'registTime', align: 'center' ,fixed:'right'},
                    { label: '协议价(元)', param: 'registTime', align: 'center' ,fixed:'right'},
                    { label: '市场价(元)', param: 'registTime', align: 'center' ,fixed:'right'},
                ],
                productTagPage: {
                    currentPage: 1,
                    pageSize: 10,
                    pageTotal: 0,
                },
                query:{
                    skuName:'',
                    skuNumber:'',
                    agreeNumber:'',
                    category:'',
                    putOnStatus:''
                },
                dialogTitle:'在线调价',
                visible:false,
                adjustPriceWay:0,
                adjustValue:0
            }
        },
        computed: {},
        created() {
        },
        methods: {
            handleAdd(){
                this.$router.push({path:'/agreementAdd'})
            },
            handleAdjustPrice(){
                this.visible = true
            },
            handleCurrentChange(){

            },
            handleSizeChange(){

            },
            updateVisible(){

            },
            resetPopupData(){
                this.visible = false
            },
            submitPopupData(){

            }
        }

    }
</script>

<style scoped>

</style>
